import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";

const CancelEmployeeImportJobApiService = async (
  request: number
): Promise<boolean> => {
  const uri = `/employeeimportjob/${request}/delete_batch/`;
  const { data } = await axios.put(uri);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useCancelEmployeeImportJobApiService = () =>
  useMutation<boolean, AxiosError, number>(
    "employee_import_jobs",
    CancelEmployeeImportJobApiService
  );

export default useCancelEmployeeImportJobApiService;
